import { FC, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Dashboard } from "../../pages";
import { onFirebaseAuthStateChanged } from "../../firebase";
import { fetchMe, getUser, removeUser } from "../../utils/tokenStorage";
import { PulseLoader } from "react-spinners";

const PrivateRoute: FC = (): JSX.Element => {
  const [isReady, setIsReady] = useState(false);
  const [isAuthed, setIsAuthed] = useState(false);

  useEffect(() => {
    const unsubscribe = onFirebaseAuthStateChanged(async (user) => {
      if (user) {
        if (!getUser()) {
          await fetchMe();
        }
        setIsAuthed(true);
      } else {
        removeUser();
        setIsAuthed(false);
      }
      setIsReady(true);
    });
    return unsubscribe;
  }, []);

  if (!isReady) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <PulseLoader color={"#7D4AFB"} />
      </div>
    );
  }

  return isAuthed ? <Dashboard /> : <Navigate to="/signIn" />;
};

export default PrivateRoute;
